import React from "react";
import "./forefeitByModal.css"; 

const ForfeitByModal = (props) => {
  return (
    <div className={`overlay ${props.isVisible ? "visible" : "hidden"}`} onClick={props.onBackdropPress}>
      <div className="modal-view" onClick={(e) => e.stopPropagation()}>
        <h2 className="heading">FORFEITED BY</h2>
        {props.teamNames.map((team, index) => (
          <button onClick={() => props.selectForfeitBy(team)} key={index} className="forfeitBtn">
            {team}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ForfeitByModal;
